export default __webpack_public_path__ + "static/media/fatale.287e6a97.png";